import { useQuery } from "@tanstack/react-query";

import { getDataFromResponse } from "~/api/axiosUtils.ts";
import { getAllGenders } from "~/modules/humanResources/api/gender/genderApiDispatchers.ts";

const ENTITY_QUERY_KEY = "gender";

export const ALL_GENDERS_QUERY_KEY = [ENTITY_QUERY_KEY, "all"];

export const useAllGenders = (enabled: boolean = true) => useQuery({
	queryKey: ALL_GENDERS_QUERY_KEY,
	queryFn: () => getAllGenders().then(getDataFromResponse),
	enabled,
});